import { render, staticRenderFns } from "./write-royalty-popup.vue?vue&type=template&id=2dcbfdfa"
import script from "./write-royalty-popup.vue?vue&type=script&lang=js"
export * from "./write-royalty-popup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports